// 智能感知监测设备
const SensorConfig = [{
    Resource: 108,
    Code: 'yelvsu',
    Alias: '叶绿素',
    Category: '智能监测',
    GuagedText: '0',
    Installed: false,
    DataType: 'time'
}, {
    Resource: 107,
    Code: 'fugaidu',
    Alias: '覆盖度',
    Category: '智能监测',
    GuagedText: '0',
    Installed: false,
    DataType: 'time'
}, {
    Resource: 109,
    Code: 'yemianji',
    Alias: '叶面积指数',
    Category: '智能监测',
    GuagedText: '0',
    Installed: false,
    DataType: 'time'
}, {
    Resource: 105,
    Code: 'ndvi',
    Alias: '植被指数NDVI',
    Category: '智能监测',
    GuagedText: '0',
    Installed: false,
    DataType: 'time'
}, {
    Resource: 106,
    Code: 'zhugao',
    Alias: '株高',
    Category: '影像监测',
    GuagedText: '0',
    Installed: false,
    DataType: 'time'
}, {
    Resource: 147,
    Code: 'yese',
    Alias: '叶色',
    Category: '影像监测',
    GuagedText: '0',
    Installed: false,
    DataType: 'time'
}, {
    Resource: 113,
    Code: 'pingzhengdu',
    Alias: '土地平整度',
    Category: '影像监测',
    GuagedText: '0',
    Installed: false,
    DataType: 'time'
}, {
    Resource: 113,
    Code: 'cucaodu',
    Alias: '土壤颗粒粗糙度',
    Category: '影像监测',
    GuagedText: '0',
    Installed: false,
    DataType: 'time'
}]

export default {
    SensorConfig
}
